import i18n from '@/i18n';

/**
 * 半托管兜底站点。entries 为 [siteId, 中文名]，展示名在调用时按当前语言解析。
 * @param {string} group workbench 下的分组，如 temuSite / tiktokSite
 * @param {Array<[string, string]>} entries
 */
export function labeledSiteOptions(group, entries) {
  return entries.map(([value, fallback]) => ({
    value,
    label: i18n.t(`${group}.s${value}`, {
      ns: 'workbench',
      defaultValue: fallback,
    }),
  }));
}
